// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Ogw","question":"styles_question__azMZh","inputVisibleButton":"styles_inputVisibleButton__1vJkf","note":"styles_note__2RrdB"};